// Session-scoped keys for in-progress activity form drafts (see useActivityGroupData).

export function getCreateActivityDraftKey(companyId: number): string {
    return `create-activity-state-${companyId}`;
}

export function getEditActivityDraftKey(companyId: number, groupId: number): string {
    return `edit-activity-group-state-${companyId}-${groupId}`;
}

export function clearCreateActivityDraft(companyId: number): void {
    sessionStorage.removeItem(getCreateActivityDraftKey(companyId));
}

export function clearEditActivityDraft(companyId: number, groupId: number): void {
    sessionStorage.removeItem(getEditActivityDraftKey(companyId, groupId));
}
